__turbopack_context__.v({
  "underline": "TemplateRating-module-scss-module__CvbWWW__underline",
});
